import httpClient from './httpClient'
import httpClientWithNoToken from './httpClientWithNoToken'

class accountApi {
  /**
   * アカウント一覧を取得
   */
  static async getList() {
    try {
      const res = await httpClient.get('/account')
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getList')
      throw e
    }
  }

  static async getListWithParams(params) {
    try {
      const res = await httpClient.get('/account', { params: params })
      return res.data
    } catch (e) {
      console.log(e)
    }
  }

  static async search(query, pageSize, pageNo) {
    try {
      const res = await httpClient.post('/account/search', {
        query,
        pageSize,
        pageNo,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  }

  static async searchInvitations(
    query,
    pageSize,
    pageNo,
    sortKey,
    sortDirection,
  ) {
    try {
      const res = await httpClient.post('/account/invite/unregistered', {
        query,
        pageSize,
        pageNo,
        sortKey,
        sortDirection,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * 自分自身のアカウントを取得
   */
  static async getMe() {
    try {
      const res = await httpClient.get('/account/me')
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getMe')
      throw e
    }
  }
  /**
   * 自分が所属しているシステムオーナ情報を取得
   */
  static async getSystemOwner() {
    try {
      const res = await httpClient.get('/system_owner/me')
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getSystemOwner')
      throw e
    }
  }

  /**
   * アカウント権限系 API
   */
  // 広告主権限 取得
  static async getAdvertiserAccountAuth(advertiserId, accountId) {
    try {
      const res = await httpClient.get(
        `/account/advertiser/${advertiserId}/auth`,
        {
          params: {
            account_id: accountId,
          },
        },
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getMe')
      throw e
    }
  }
  // アカウント更新
  static async putAccount(accountId, reqeustBody) {
    try {
      const res = await httpClient.put(`/account/${accountId}`, reqeustBody)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.putAccount')
      throw e
    }
  }
  // パスワードリセットトークン発行
  static async postResetPasswordToken(reqeustBody) {
    try {
      const res = await httpClientWithNoToken.post(
        `/account/password/token`,
        reqeustBody,
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.postPasswordResetToken')
      throw e
    }
  }
  // パスワードリセット実行
  static async postResetPassword(reqeustBody) {
    try {
      const res = await httpClientWithNoToken.post(
        `/account/password/reset`,
        reqeustBody,
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.postPasswordReset')
      throw e
    }
  }
  // パスワード更新
  static async putPassword(reqeustBody) {
    try {
      const res = await httpClient.put(`/account/password`, reqeustBody)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.putPassword')
      throw e
    }
  }
  // 招待ユーザーの新規登録
  static async register(params) {
    try {
      const res = await httpClient.post(`/account/register`, params)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.postRegister')
      throw e
    }
  }
  // 招待されたユーザーの名前とemail、所属を取得
  static async getInvitedUser(token) {
    try {
      const res = await httpClient.get(`/account/invite?token=${token}`)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getInvitedUser')
      throw e
    }
  }
  // 広告主権限 更新
  static async postAdvertiserAccountAuth(advertiserId, accountId, reqeustBody) {
    try {
      const res = await httpClient.post(
        `/account/advertiser/${advertiserId}/auth?account_id=${accountId}`,
        reqeustBody,
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getMe')
      throw e
    }
  }
  // 代理店権限 取得
  static async getAgencyAccountAuth(agencyId, accountId) {
    try {
      const res = await httpClient.get(`/account/agency/${agencyId}/auth`, {
        params: {
          account_id: accountId,
        },
      })
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getMe')
      throw e
    }
  }
  // 代理店権限 更新
  static async postAgencyAccountAuth(agencyId, accountId, reqeustBody) {
    try {
      const res = await httpClient.post(
        `/account/agency/${agencyId}/auth?account_id=${accountId}`,
        reqeustBody,
      )
      console.log(res)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.getMe')
      throw e
    }
  }

  static async invite(params, systemOwnerId, agencyId, advertiserId) {
    try {
      let url = `/account/invite`
      if (systemOwnerId != null) {
        url += `?system_owner_id=${systemOwnerId}`
      } else if (agencyId != null) {
        url += `?agency_id=${agencyId}`
      } else {
        url += `?advertiser_id=${advertiserId}`
      }
      const res = await httpClient.post(url, params)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.invite')
      throw e
    }
  }

  static async deleteInvite(inviteAccountId) {
    try {
      const res = await httpClient.delete(`/account/invite/${inviteAccountId}`)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.deleteInvite')
      throw e
    }
  }
  static async edit(accountId, params) {
    try {
      const res = await httpClient.put(`/account/${accountId}`, params)
      return res.data
    } catch (e) {
      console.log(e, 'error of accountApi.edit')
      throw e
    }
  }
}

export default accountApi
